// Run this before any other code
/* eslint-disable */
(function () {
  // Make XMLHttpRequest methods configurable to avoid issues in some older browsers
  const xhr = XMLHttpRequest.prototype;
  const props = ['open', 'send', 'setRequestHeader', 'abort'];

  for (let i = 0; i < props.length; i++) {
    const prop = props[i];
    // @ts-ignore
    const original = xhr[prop];
    try {
      Object.defineProperty(xhr, prop, {
        configurable: true,
        enumerable: true,
        writable: true,
        value: original,
      });
    } catch (e) {
      console.warn(`Could not make ${prop} configurable:`, e);
    }
  }
})();
